// Generated by DesignToCode

import { CommonModule } from "@angular/common";
import {
  Component,
  ElementRef,
  ViewChild,
  computed,
  input,
  output,
} from "@angular/core";

export type SecondaryButtonSize = "small" | "medium" | "large";

@Component({
  selector: "app-secondary-button",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./secondary-button.html",
})
export class SecondaryButton {
  @ViewChild("button") public buttonRegularRef: ElementRef<HTMLElement> | null =
    null;
  public buttonClicked = output<boolean>();

  public size = input<SecondaryButtonSize>("medium");
  public label = input<string>("");
  public disabled = input<boolean>(false);
  public fullWidth = input<boolean>(false);

  public buttonClasses = computed(() => {
    const classes: string[] = [];

    // Base classes
    classes.push(
      "group",
      "flex",
      "flex-col",
      "flex-nowrap",
      "items-center",
      "justify-center",
      "rounded",
      "h-fit",
      "outline-none",
    );

    // Width
    classes.push(this.fullWidth() ? "w-full" : "w-fit");

    // Size-based padding
    if (this.size() === "small") {
      classes.push("pl-4", "pr-4", "pt-2", "pb-2");
    } else if (this.size() === "large") {
      classes.push("pl-10", "pr-10", "pt-4", "pb-4");
    } else {
      classes.push("pl-6", "pr-6", "pt-3", "pb-3");
    }

    // Disabled vs interactive states
    if (this.disabled()) {
      classes.push("bg-[#E3E9F2]", "opacity-50", "cursor-not-allowed");
    } else {
      classes.push(
        "bg-[#E3E9F2]",
        "hover:bg-[#DDE3EC]",
        "focus:bg-[#DDE3EC]",
        "active:bg-[#C2CCD9]",
        "cursor-pointer",
      );
    }

    return classes;
  });

  public textClasses = computed(() => {
    const classes: string[] = [];

    // Base text classes
    classes.push(
      "flex",
      "flex-row",
      "flex-wrap",
      "items-start",
      "justify-start",
      "h-fit",
      "w-fit",
      "text-black",
      "tracking-normal",
      "text-center",
      "align-middle",
    );

    // Size-based text styles
    if (this.size() === "small") {
      classes.push("text-xs", "font-semibold", "leading-4");
    } else if (this.size() === "large") {
      classes.push("text-base", "font-bold", "leading-6");
    } else {
      classes.push("text-sm", "font-semibold", "leading-5");
    }

    return classes;
  });

  public submit(): void {
    if (this.disabled()) return;
    this.buttonRegularRef?.nativeElement.blur();
    this.buttonClicked.emit(true);
  }
}
